import {NgModule} from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { AsideNavComponent } from './aside-nav/aside-nav.component';
import { FooterComponent } from './footer/footer.component';
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { TooltipsComponent } from './tooltips/tooltips.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import { HrefPreventDefaultDirective } from '../../Shared/directives/href-prevent-default.directive';
import { UnwrapTagDirective } from '../../Shared/directives/unwrap-tag.directive';
import { TermsConditionsComponent } from '../../Shared/component/termsConditions.component';

@NgModule({
	declarations: [
		LayoutComponent,
		HeaderNavComponent,
		AsideNavComponent,
		FooterComponent,
		QuickSidebarComponent,
		ScrollTopComponent,
		TooltipsComponent,
		HrefPreventDefaultDirective,
		UnwrapTagDirective,
		TermsConditionsComponent
	],
	exports: [
		LayoutComponent,
		HeaderNavComponent,
		AsideNavComponent,
		FooterComponent,
		QuickSidebarComponent,
		ScrollTopComponent,
		TooltipsComponent,
		HrefPreventDefaultDirective,
		TermsConditionsComponent
	],
	imports: [
		CommonModule,
		RouterModule,
	]
})
export class LayoutModule {
}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/theme/layouts/layout.module.ts